import { render, staticRenderFns } from "./JcomBusinessCategoryEdit.vue?vue&type=template&id=92fe2044"
import script from "./JcomBusinessCategoryEdit.vue?vue&type=script&lang=js"
export * from "./JcomBusinessCategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomBusinessCategoryEdit.vue?vue&type=style&index=0&id=92fe2044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports